import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

export function Panel({ children, className = '', padded = true }: Props) {
  return (
    <section
      className={`rounded-lg border border-background-200 bg-background-50 ${padded ? 'p-5' : ''} ${className}`}
    >
      {children}
    </section>
  );
}

interface PanelHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}

export function PanelHeader({ title, subtitle, action, className = '' }: PanelHeaderProps) {
  return (
    <div className={`flex items-start justify-between gap-4 px-5 pb-3 pt-4 ${className}`}>
      <div className="min-w-0">
        <h2 className="text-sm font-semibold text-foreground-950">{title}</h2>
        {subtitle && <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export default Panel;